// Internal helper — not exported from the package barrel.

/** Freeze a plain value graph (objects + arrays) in place, so catalog data is immutable at runtime. */
export function deepFreeze<T>(value: T): T {
  if (value && typeof value === 'object' && !Object.isFrozen(value)) {
    for (const child of Object.values(value as Record<string, unknown>)) deepFreeze(child);
    Object.freeze(value);
  }
  return value;
}
